import van from 'vanjs-core';
import {BigTag} from "../../components/big-tag";
import {
    energySaved,
    treesSaved,
    carYears,
    computersRan,
    powerProductionValue,
    nominalPower,
    authorName,
    imageUrl
} from "../../state-variables";

const {div, img, span, br} = van.tags;

// Hlavní obsahové okno na 2. obrazovce
export const MainContent = () => {

    return div({class: "w-100 main-content p-0 m-0 justify-content-center d-flex flex-column main-content-radius"},
        div({class: "w-100 row container-fluid p-0 m-0 eco-container sm-reverse", style: "z-index: 1;"},
            div({class: "col-lg-4 col-md-12 d-flex flex-column align-items-center bg-light-see-through justify-content-center eco-padding"},
                div({class: "section-aligner hf"},
                    div({class: "item d-flex flex-column align-items-center w-100"},
                        BigTag("ZADRŽENO CO2", "TOTAL CO2 SAVED", energySaved, "ton", true),
                    ),
                    div({class: "mobile-spacer"}),
                    div({class: "item d-flex flex-column align-items-center w-100"},
                        span({class: "text-dark-blue big-tag-text mb-2"}, "ENVIROMENTAL EQUIVALENTS:"),
                        span({class: "text-green big-tag-text"}, "ENVIROMENTÁLNÍ EKVIVALENTY:"),
                    ),
                    div({class: "mobile-spacer"}),
                    div({class: "item d-flex flex-column align-items-center w-100"},
                        div({class: "d-flex flex-row justify-content-end ms-auto"},
                            div({class: "d-flex flex-column align-items-end"},
                                span({class: "big-text text-dark-blue"}, () => treesSaved.val),
                                span({class: "text-dark-blue md-tag-text mb-1"}, "SAVED TREES"),
                                span({class: "text-green md-tag-text"}, "STROMŮ UŠETŘENO"),
                            ),
                            div({class: "tree-wrap"},
                                img({src:"/icons/g672.svg",alt:"little_tree", class: "tree-icon"}),
                            ),
                        ),
                    ),
                    div({class: "mobile-spacer"}),
                    div({class: "item d-flex flex-column align-items-center w-100"},
                        div({class: "d-flex flex-row justify-content-end ms-auto"},
                            div({class: "d-flex flex-column align-items-end"},
                                span({class: "big-text text-dark-blue"}, () => carYears.val),
                                span({class: "text-dark-blue md-tag-text mb-1"}, "YEARS OF NORMAL OPERATON"),
                                span({class: "text-dark-blue md-tag-text mb-1"}, "OF A PASSENGER CAR"),
                                span({class: "text-green md-tag-text"}, "LET BĚŽNÉHO PROVOZU OSOBNÍHO VOZU"),
                            ),
                            div({class: "tree-wrap"},
                                img({src:"/icons/g673.svg",alt:"car", class: "tree-icon"}),
                            ),
                        ),
                    ),
                    div({class: "mobile-spacer"}),
                    div({class: "item d-flex flex-column align-items-center w-100"},
                        div({class: "d-flex flex-row justify-content-end ms-auto"},
                            div({class: "d-flex flex-column align-items-end"},
                                span({class: "big-text text-dark-blue"}, () => computersRan.val),
                                span({class: "text-dark-blue md-tag-text mb-1"}, "COMPUTERS POWERED FOR 1 YEAR"),
                                span({class: "text-green md-tag-text"}, "POČÍTAČŮ NAPÁJENÝCH 1 ROK"),
                            ),
                            div({class: "tree-wrap"},
                                img({src:"/icons/g674.svg",alt:"computer", class: "tree-icon car-icon"}),
                            ),
                        ),
                    ),
                    div({class: "mobile-spacer"}),
                    div({class: "mobile-spacer"}),
                    div({class: "item d-flex flex-column align-items-center w-100 sm-show"},
                        div({class: "item flex-row align-items-center justify-content-between w-100 sm-show mb-3"},
                            div({class: "item d-flex flex-column align-items-center w-50 pe-3"},
                                div({class: "fw-bold text-dark"},
                                    span({class: "big-text text-dark-blue smaller"}, () => powerProductionValue.val),
                                    span({class: "unit-text ms-2 text-dark-blue"}, "kW"),
                                ),
                                div({class: "bg-blue pl-tag w-100 md-tag-padding md-tag-border wf column-tag"},
                                    span({class: "text-white me-2 md-tag-text no-newline"}, "POWER PRODUCTION"),
                                    div({class: "spacer"}),
                                    span({class: "text-light-blue md-tag-text no-newline"}, "AKTUÁLNÍ PRODUKCE"),
                                ),
                            ),
                            div({class: "item d-flex flex-column align-items-center w-50 ps-3"},
                                div({class: "fw-bold text-dark"},
                                    span({class: "big-text text-dark-blue smaller"}, () => nominalPower.val),
                                    span({class: "unit-text ms-2 text-dark-blue"}, "kWp"),
                                ),
                                div({class: "bg-blue pl-tag w-100 md-tag-padding md-tag-border wf column-tag"},
                                    span({class: "text-white me-2 md-tag-text"}, "NOMINAL POWER"),
                                    div({class: "spacer"}),
                                    span({class: "text-light-blue md-tag-text"}, "JMENOVITÝ VÝKON"),
                                ),
                            ),
                        ),
                    ),
                ),
            ),
            div({class: "col-lg-8 col-md-12 d-flex flex-column align-items-center justify-content-between section-padding eco-background", style: () => imageUrl.val ? `--custom-bg:url(${imageUrl.val});` : ''},
                span({class: "eco-image-text text-white"}, "SUSTAINABLE", br(), "WITH SOLAR ENERGY"),
                div({class: "eco-logos d-flex flex-row align-items-center bg-white justify-content-between"},
                  img({src: "/icons/image522.svg", alt: "esg rating"}),
                  img({src: "/icons/g675.svg", alt: "airport carbon accreditation"}),
                ),
                div({class: "bg-white pl-tag w-100 md-tag-padding md-tag-border wf eco-tag", style: authorName.val === "Jméno Příjmení" ? "display: none !important" : ""},
                    span({class: "text-dark-blue me-2 md-tag-text"}, "PHOTO"),
                    span({class: "text-light-blue md-tag-text"}, "FOTOGRAFIE"),
                    span({class: "text-dark-blue ms-4 md-tag-text"}, () => authorName.val),
                ),
            ),
        ),
    );
};